import {ResourcesErrors} from '.';
import {ErrorAction, ErrorCode} from '@/services/ErrorsService/ErrorsService.constants';

import {HttpStatus} from '@specials/project-user';

export const errors: ResourcesErrors = {
  errorCodes: [
    {
      errorCodes: [ErrorCode.TestError],
      mb: {
        title: 'Что-то пошло не так',
        text: 'Пожалуйста, закройте экран и зайдите еще раз. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, вам помогут',
      },
      web: {
        title: 'Что-то пошло не так',
        text: 'Попробуйте авторизоваться еще раз',
      },
    },
    {
      errorCodes: [
        ErrorCode.ExtractToken,
        ErrorCode.ClientNotExistWithSession,
        ErrorCode.SessionExpired,
        ErrorCode.GetProductLoyaltiesV2,
        ErrorCode.InvalidCitizenship,
        ErrorCode.SSOTokenNotExist,
        ErrorCode.SSOTokenInactive,
        ErrorCode.MobilePhoneIsNotDefined,
        ErrorCode.ClientHasNotSSO_ID,
      ],
      mb: {
        title: 'Что-то пошло не так',
        text: 'Пожалуйста, закройте экран и зайдите еще раз. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, вам помогут',
      },
      web: {
        title: 'Что-то пошло не так',
        text: 'Попробуйте авторизоваться еще раз',
        buttonText: 'Войти',
        action: ErrorAction.Logout,
      },
    },
    {
      errorCodes: [
        ErrorCode.ErrorRequestDB,
        ErrorCode.InvalidTransactionTypeDuringQueries,
        ErrorCode.UnknownClusterKafka,
        ErrorCode.KafkaConsumerAlreadyRunning,
        ErrorCode.KafkaMessageNotMatchesContract,
        ErrorCode.InternalServer,
        ErrorCode.QueryFailed,
        ErrorCode.KafkaMessageSend,
        ErrorCode.KafkaConnection,
        ErrorCode.InvalidParametersRequestToDB,
        ErrorCode.UnknownClusterKafkaConsumer,
        ErrorCode.ClientDuplicated,
        ErrorCode.RequestWithoutTransaction,
        ErrorCode.SettingsNotMatchScheme,
        ErrorCode.InitKeyDB,
        ErrorCode.QueryToCacheTimeoutExpired,
        ErrorCode.QueriesAndTransactionsUses,
        ErrorCode.ParallelRequestsForTaskProgressChanges, // TODO ретраи
        ErrorCode.DataInQueueNotMatchQueueType,
        ErrorCode.DecodingProtobufMessage,
        ErrorCode.EncodingProtobufMessage,
        ErrorCode.LoadProtobufScheme,
        ErrorCode.DuplicatedBrokerAccount,
      ],
      mb: {
        title: 'Не получилось войти',
        text: 'Пожалуйста, закройте экран и зайдите еще раз. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, вам помогут',
        action: ErrorAction.Reload,
      },
      web: {
        title: 'Не получилось войти',
        buttonText: 'Перезагрузить',
        text: 'Перезагрузите страницу. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, вам помогут',
        action: ErrorAction.Reload,
      },
    },
    {
      errorCodes: [ErrorCode.UserBanned],
      mb: {
        title: 'К сожалению, вы не сможете сыграть в Спейс‑Инвесторс',
      },
      web: {
        title: 'К сожалению, вы не сможете сыграть в Спейс‑Инвесторс',
        action: ErrorAction.Logout,
        buttonText: 'Войти под другим аккаунтом',
      },
    },
    {
      errorCodes: [ErrorCode.InvalidAge],
      mb: {
        title: 'Кажется, вам меньше 14 лет',
        text: 'В Спейс‑Инвесторс сыграть пока не получится. Посмотрите другие наши проекты',
      },
      web: {
        title: 'Кажется, вам меньше 14 лет',
        text: 'В Спейс‑Инвесторс сыграть пока не получится. Посмотрите другие наши проекты',
        buttonText: 'Войти под другим аккаунтом',
        action: ErrorAction.Logout,
      },
    },
    {
      errorCodes: [ErrorCode.ProductLoyalties, ErrorCode.SiebelIdIsNotDefined],
      mb: {
        title: 'У вас нет карты Black',
        text: 'Чтобы сыграть в Спейс‑Инвесторс, оформите карту Black от Т‑Банка',
      },
      web: {
        title: 'У вас нет карты Black',
        text: 'Чтобы сыграть в Спейс‑Инвесторс, оформите карту Black от Т‑Банка',
        buttonText: 'Оформить',
        action: ErrorAction.LogoutWithRedirectToMainForm,
      },
    },
    {
      errorCodes: [ErrorCode.UserIsNotResident],
      mb: {
        title: 'Игра недоступна',
        text: 'В Спейс‑Инвесторс могут играть только резиденты РФ. Посмотрите другие наши проекты',
      },
      web: {
        title: 'Игра недоступна',
        text: 'В Спейс‑Инвесторс могут играть только резиденты РФ. Посмотрите другие наши проекты',
        buttonText: 'На главную',
        action: ErrorAction.LogoutWithRedirectToMainForm,
      },
    },
    {
      errorCodes: [ErrorCode.TaskIsNotExist],
      mb: {
        title: 'Что‑то пошло не так',
        text: 'Не смогли определить задание. Попробуйте еще раз',
      },
      web: {
        title: 'Что‑то пошло не так',
        text: 'Не смогли определить задание. Попробуйте еще раз',
      },
    },
    {
      errorCodes: [ErrorCode.TaskProcessCompleted],
      mb: {
        title: 'Что‑то пошло не так',
        text: 'Пожалуйста, закройте экран и зайдите еще раз. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, вам помогут',
      },
      web: {
        title: 'Что‑то пошло не так',
        text: 'Перезагрузите страницу. Если не помогло, сделайте скриншот этого экрана и обратитесь в поддержку, вам помогут',
      },
    },
    {
      errorCodes: [ErrorCode.InvitedFriendInTheGame],
      mb: {
        title: 'Вы уже в игре',
        text: 'Друг не сможет получить награду за ваше приглашение',
        buttonText: 'К игре',
        action: ErrorAction.AuthReloadWithoutQueryRef,
      },
      web: {
        title: 'Вы уже в игре',
        text: 'Друг не сможет получить награду за ваше приглашение',
        buttonText: 'К игре',
        action: ErrorAction.AuthReloadWithoutQueryRef,
      },
    },
    {
      errorCodes: [ErrorCode.InvitedFriendInvalidRefId],
      mb: {
        title: 'Что‑то пошло не так',
        text: 'Сделайте скриншот этого экрана и обратитесь в поддержку, мы поможем',
      },
      web: {
        title: 'Что‑то пошло не так',
        text: 'Сделайте скриншот этого экрана и обратитесь в поддержку, мы поможем',
      },
    },
    {
      errorCodes: [ErrorCode.RateLimiting, ErrorCode.EconnAborted],
      mb: {
        title: 'Игра временно недоступна',
        text: 'Мы уже разбираемся с проблемой, возвращайтесь через 15 минут',
      },
      web: {
        title: 'Игра временно недоступна',
        text: 'Мы уже разбираемся с проблемой, возвращайтесь через 15 минут',
      },
    },
  ],
  httpCodes: [
    {
      httpCodes: [HttpStatus.SERVICE_UNAVAILABLE],
      mb: {
        title: 'Что-то пошло не так',
        text: 'Уже разбираемся. Попробуйте зайти в игру через 15 минут.',
      },
      web: {
        title: 'Что-то пошло не так',
        text: 'Уже разбираемся. Попробуйте зайти в игру через 15 минут.',
      },
    },
    {
      httpCodes: [HttpStatus.TOO_MANY_REQUESTS],
      mb: {
        title: 'Игра временно недоступна',
        text: 'Мы уже разбираемся с проблемой, возвращайтесь через 15 минут',
      },
      web: {
        title: 'Игра временно недоступна',
        text: 'Мы уже разбираемся с проблемой, возвращайтесь через 15 минут',
      },
    },
  ],
  fallback: {
    mb: {
      title: 'Что-то пошло не так',
      text: 'Пожалуйста закройте экран и зайдите еще раз',
      buttonText: '',
    },
    web: {
      text: undefined,
      title: 'Что-то пошло не так',
      buttonText: 'Перезагрузить',
      action: ErrorAction.LogoutWithReload,
    },
  },
};
